// extracted by mini-css-extract-plugin
export default {"ui_kit_switch":"switch_ui_kit_switch__iTWhR","ui_kit_switch_item":"switch_ui_kit_switch_item__VDO-m","ui_kit_switch_item_selected":"switch_ui_kit_switch_item_selected__+xE32"};